import { DROPDOWN_PAGE, PagedResult, panelDelete, panelGet, panelPost, panelPut } from "./panel.api";
import { Category, CategoryPayload } from "./types";

/** category — /category */
export const categoryApi = {
  getAll: () => panelGet<Category[]>("/category", DROPDOWN_PAGE),
  /** GET /category/get-category-list: every category, or — with a region — the ones set up in it. */
  byRegion: (regionId?: string) =>
    panelGet<PagedResult<Category>>("/category/get-category-list", { ...DROPDOWN_PAGE, regionId }),
  getById: (id: string) => panelGet<Category>(`/category/${id}`),
  create: (payload: CategoryPayload) => panelPost<Category>("/category", payload),
  update: (id: string, payload: CategoryPayload) => panelPut<Category>(`/category/${id}`, payload),
  remove: (id: string) => panelDelete(`/category/${id}`),
};

/**
 * v2.1 sets a category up once per region, so the catalog repeats each name.
 * One entry per name + code: the first copy's fields, plus every copy's id.
 */
export const uniqueCategories = (rows: Category[]) =>
  Object.values(
    rows.reduce<Record<string, Category & { ids: string[] }>>((groups, row) => {
      const key = `${row.categoryName ?? ""}|${row.categoryCode ?? ""}`.trim().toLowerCase();
      if (groups[key]) groups[key].ids.push(row.id as string);
      else groups[key] = { ...row, ids: [row.id as string] };
      return groups;
    }, {})
  );
